import searchIcon from "./image/searchIcon.png";
import profileImage from "./image/profileImage.png";

export const requestIcon = {
  searchIcon: searchIcon,
  profileImage: profileImage,
};

export enum REQUEST_TYPE {
  FRIEND_REQUEST,
  PENDING_REQUEST,
  GROUP_REQUEST
};
